import { MAILTO } from "@/lib/mailto";

const BG_URL =
  "https://customer-assets.emergentagent.com/job_ryder-consulting/artifacts/8gmr4b5p_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2009_32_41%20PM.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="section-hero"
      className="bg-sand relative"
      style={{
        backgroundImage: `url('${BG_URL}')`,
        backgroundPosition: "right center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Lightening overlay: stronger on mobile, softer on desktop */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none bg-[rgba(245,241,234,0.6)] md:bg-[rgba(245,241,234,0.32)]"
        data-testid="hero-bg-overlay"
      />
      <div className="relative mx-auto max-w-[1100px] px-6 py-24 md:px-10 md:py-32 lg:py-40">
        <div className="max-w-[880px] rise">
          <p className="eyebrow" data-testid="hero-eyebrow">
            <span>Project-based executive consulting</span>
            <span
              aria-hidden="true"
              style={{
                margin: "0 0.6em",
                opacity: 0.4,
                display: "inline-block",
              }}
            >
              |
            </span>
            <span>Key initiatives, driven to done</span>
          </p>

          <h1 className="hero-headline mt-6" data-testid="hero-headline">
            <span>{"Project-based,\u00A0by\u00A0design."}</span>
            <span>{"Built\u00A0to\u00A0hand\u00A0off."}</span>
          </h1>

          <p
            className="lede mt-8"
            data-testid="hero-sub"
            style={{
              fontSize: "clamp(1.0625rem, 1.4vw, 1.1875rem)",
              maxWidth: "540px",
              lineHeight: 1.6,
            }}
          >
            {"For owners who are done being the bottleneck. I come in for a defined project, get it across the line with your team, and leave them able to run the next one without me. Or you."}
          </p>

          <div className="mt-10">
            <a
              href={MAILTO}
              data-testid="hero-cta-start-conversation"
              className="btn-primary"
            >
              Start a conversation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
